import { OptionWithValues } from './option-with-values';

export class OptionDropdown extends OptionWithValues {
    readonly type = 'dropdown';
}
